<template>
    <div class="center-page">
        <el-page-header style="margin-bottom: 20px;" @back="$router.back()"
                        :content="`${id?'编辑':'新增'}故事`"></el-page-header>

        <el-form :model="addForm" :rules="rules" label-position="right" label-width="150px" ref="forms">
            <el-form-item label="故事类型：">
                <el-radio-group style="margin-top: 12px;" v-model="type">
                    <el-radio :label="1">购物攻略</el-radio>
                    <el-radio :label="2">景点･温泉</el-radio>
                    <el-radio :label="3">日本美食</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <el-input style="width: 50%;" v-model="addForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="封面照片：" prop="cover">
                <el-upload
                        action=""
                        class="avatar-uploader"
                        :http-request="uploadCover"
                        :show-file-list="false">
                    <img v-if="addForm.cover" :src="`/api/v1/file/${addForm.cover}`" class="avatar" alt="">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="展示照片：" required>
                <transition-group tag="div" name="drag" class="img-content">
                    <img @dragstart="handlerStart(item,index)"
                         @dragend="handlerEnd(item,index)"
                         @dragenter="handlerEnter(item,index)"
                         @click="delImg(index)"
                         v-for="(item,index) in addForm.image"
                         :key="item"
                         class="img-content-item" :src="`/api/v1/file/${item}`" alt="">
                    <el-upload
                            action=""
                            key="upload"
                            :http-request="uploadImage"
                            class="avatar-uploader"
                            :show-file-list="false">
                        <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                    </el-upload>
                </transition-group>
            </el-form-item>
            <el-form-item label="介绍：" prop="content">
                <el-input type="textarea"
                          v-model="addForm.content"
                          placeholder="请输入介绍"
                          :autosize="{ minRows: 8, maxRows: 16}"
                          maxlength="2500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="类型：" prop="type_id">
                <el-select v-model="addForm.type_id" filterable>
                    <el-option v-for="(item,index) in currentTypeList" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="位置：" prop="area_id">
                <el-select v-model="addForm.area_id" filterable>
                    <el-option v-for="(item,index) in cityList" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                <el-input style="width: 60%;" v-model="addForm.address" placeholder="请输入详细地址">
                    <el-button slot="append" @click="showMap=true;">地图选点</el-button>
                </el-input>
            </el-form-item>
            <el-form-item label="到达方式：" prop="arrival_pattern">
                <el-input type="textarea"
                          v-model="addForm.arrival_pattern"
                          placeholder="请输入介绍"
                          :autosize="{ minRows: 4, maxRows: 8}"
                          maxlength="1000" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="开放时间：" prop="closing_time">
                <el-date-picker
                        v-model="addForm.opening_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <!--<el-form-item label="关闭时间：" prop="closing_time">
                <el-date-picker
                        v-model="addForm.closing_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>-->
            <el-form-item label="电话号码：" prop="tel">
                <el-input style="width: 50%;" v-model="addForm.tel" placeholder="请输入电话号码"></el-input>
            </el-form-item>
            <el-form-item label="人均消费：" prop="per_capita">
                <el-input style="width: 50%;" v-model="addForm.per_capita" placeholder="请输入人均消费">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                    <el-select style="width: 120px;" slot="append" v-model="addForm.currency">
                        <el-option label="人民币" value="人民币"></el-option>
                        <el-option label="日元" value="日元"></el-option>
                    </el-select>
                </el-input>
            </el-form-item>
            <el-form-item label="房源推荐">
                <el-select v-model="addForm.house_id" multiple>
                    <el-option v-for="(item,index) in houseList" :key="index" :label="item.title" :value="item.id">
                        <div class="select-item-content">
                            <img :src="`/api/v1/file/${item.cover}`" alt="">
                            <div>{{item.title}}</div>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button v-if="id" type="primary" @click="handlerEdit">保存</el-button>
                <el-button v-else type="primary" @click="handlerConfirm">提交发布</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="地图选点" :visible.sync="showMap" :close-on-click-modal="false">
            <baidu-map class="map-content"
                       scroll-wheel-zoom
                       @ready="mapReady"
                       @click="handlerMapClick"
                       :center="getMapCenter"
                       :zoom="12">
                <bm-marker v-if="addForm.lon&&addForm.lat" :position="{lng: addForm.lon, lat: addForm.lat}"></bm-marker>
            </baidu-map>
            <div class="f-14 color-red mt-20" v-if="addForm.address">已选地址：<span class="fw-b">{{addForm.address}}</span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {formVerify, delToast} from '@/utlis/decorators'

    export default {
        name: "addStory",
        data() {
            return {
                id: '',
                type: 1,
                showMap: false,
                loading: false,
                addForm: {
                    title: '',
                    cover: '',
                    image: [],
                    type_id: '',
                    content: '',
                    address: '',
                    area_id: '',
                    arrival_pattern: '',
                    opening_time: '',
                    closing_time: '',
                    tel: '',
                    per_capita: '',
                    house_id: [],
                    currency: '人民币',
                    latitude: '',
                    longitude: ''
                },
                rules: {
                    title: [{required: true, message: '请输入标题', trigger: ['blur', 'change']}],
                    cover: [{required: true, message: '请上传封面', trigger: ['blur', 'change']}],
                    type_id: [{required: true, message: '请选择类型', trigger: ['blur', 'change']}],
                    content: [{required: true, message: '请输入介绍', trigger: ['blur', 'change']}],
                    area_id: [{required: true, message: '请选择地区', trigger: ['blur', 'change']}],
                    address: [{required: true, message: '请输入详细地址', trigger: ['blur', 'change']}],
                    arrival_pattern: [{required: true, message: '请输入到达方式', trigger: ['blur', 'change']}],
                    tel: [{required: true, message: '请输入电话', trigger: ['blur', 'change']}],
                    per_capita: [{required: true, message: '请输入人均消费', trigger: ['blur', 'change']}],
                },
                hotSpringType: [],
                sceneryType: [],
                cateType: [],
                houseList: []
            }
        },
        computed: {
            ...mapState(['cityList']),
            getMapCenter() {
                if (this.addForm.lon && this.addForm.lat) {
                    return {lng: this.addForm.lon, lat: this.addForm.lat}
                } else if (this.addForm.area_id) {
                    let obj = this.cityList.find(it => it.id === this.addForm.area_id)
                    return obj.name
                }
                return '东京'
            },
            currentTypeList() {
                if (this.type === 1) {
                    return this.hotSpringType
                } else if (this.type === 2) {
                    return this.sceneryType
                } else if (this.type === 3) {
                    return this.cateType
                }
            }
        },
        watch: {
            type() {
                this.addForm.type_id = ''
            }
        },
        created() {
            let {type, id} = this.$route.query;
            this.type = +type || 1;
            this.id = id || '';
            this.getHotSpringType();
            this.getSceneryType();
            this.getCateType();
            this.getHouse();
            if (this.id) {
                if (this.type === 1) {
                    this.getHotSpringInfo();
                } else if (this.type === 2) {
                    this.sceneryInfo();
                } else if (this.type === 3) {
                    this.cateInfo();
                }
            }
        },
        methods: {
            @delToast('是否删除该图片？')
            async delImg(index){
                this.addForm.image.splice(index, 1)
            },
            mapReady({BMap, map}) {
                this.geoc = new BMap.Geocoder();
            },
            handlerMapClick(e) {
                this.addForm.latitude = e.point.lat;
                this.addForm.longitude = e.point.lng;
                this.geoc.getLocation(e.point, (res) => {
                    this.addForm.address = res.address
                })
            },
            async getHotSpringInfo() {
                let [e, data] = await this.$api.hotSpringInfoApi({id: this.id});
                this.addForm = data.result;
                if(!this.$isDateStr(this.addForm.closing_time)){
                    this.addForm.closing_time = '2030-10-10'
                }
                if(!this.$isDateStr(this.addForm.opening_time)){
                    this.addForm.opening_time = ''
                }
            },
            async sceneryInfo() {
                let [e, data] = await this.$api.sceneryInfoApi({id: this.id});
                this.addForm = data.result;
                if(!this.$isDateStr(this.addForm.closing_time)){
                    this.addForm.closing_time = '2030-10-10'
                }
                if(!this.$isDateStr(this.addForm.opening_time)){
                    this.addForm.opening_time = ''
                }
            },
            async cateInfo() {
                let [e, data] = await this.$api.cateInfoApi({id: this.id});
                this.addForm = data.result;
                if(!this.$isDateStr(this.addForm.closing_time)){
                    this.addForm.closing_time = '2030-10-10'
                }
                if(!this.$isDateStr(this.addForm.opening_time)){
                    this.addForm.opening_time = ''
                }
            },
            async uploadCover(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.cover = data.result;
                }
            },
            async uploadImage(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.image.push(data.result);
                }
            },
            handlerStart(item, index) {
                this.start = item
                this.startIndex = index
            },
            handlerEnd(item, index) {
                if (this.startIndex === this.endIdnex) return;
                this.addForm.image.splice(this.startIndex, 1, this.end);
                this.addForm.image.splice(this.endIdnex, 1, this.start);
            },
            handlerEnter(item, index) {
                this.end = item
                this.endIdnex = index
            },
            async getHotSpringType() {
                let [e, data] = await this.$api.hotSpringTypeApi();
                this.hotSpringType = data.result;
            },
            async getSceneryType() {
                let [e, data] = await this.$api.sceneryTypeApi();
                this.sceneryType = data.result;
            },
            async getCateType() {
                let [e, data] = await this.$api.cateTypeApi();
                this.cateType = data.result;
            },
            async getHouse() {
                let params = {
                    check: 1, // 1
                    state: 0 // 0
                }
                let [e, data] = await this.$api.houseManageApi(params);
                this.houseList = data.result.house
            },
            @formVerify()
            async hotSpringAdd() {
                this.loading = true;
                let [e, data] = await this.$api.hotSpringAddApi(this.addForm)
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('发布成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            @formVerify()
            async sceneryAdd() {
                this.loading = true;
                let [e, data] = await this.$api.sceneryAddApi(this.addForm)
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('发布成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            @formVerify()
            async cateAdd() {
                this.loading = true;
                let [e, data] = await this.$api.cateAddApi(this.addForm)
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('发布成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            handlerConfirm() {
                if (this.type === 1) {
                    this.hotSpringAdd()
                } else if (this.type === 2) {
                    this.sceneryAdd()
                } else if (this.type === 3) {
                    this.cateAdd()
                }
            },
            @formVerify()
            async hotSpringEdit(){
                this.loading = true;
                let [e, data] = await this.$api.editHotSpringApi({id: this.id, ...this.addForm})
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('保存成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            @formVerify()
            async sceneryEdit(){
                this.loading = true;
                let [e, data] = await this.$api.editSceneryApi({id: this.id, ...this.addForm})
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('保存成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            @formVerify()
            async cateEdit(){
                this.loading = true;
                let [e, data] = await this.$api.editCateApi({id: this.id, ...this.addForm})
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('保存成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            handlerEdit() {
                if (this.type === 1) {
                    this.hotSpringEdit()
                } else if (this.type === 2) {
                    this.sceneryEdit()
                } else if (this.type === 3) {
                    this.cateEdit()
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .map-content {
        width: 100%;
        height: 500px;
    }

    .select-item-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        img {
            width: 30px;
            height: 30px;
            object-fit: cover;
        }
    }

    .img-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .img-content-item {
            width: 150px;
            height: 150px;
            object-fit: cover;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

    .drag-move {
        transition: 0.3s;
    }
</style>
